var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _vm.isMessage
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger alert-margin",
            attrs: { role: "alert" },
          },
          [_vm._v(" " + _vm._s(_vm.message) + " ")]
        )
      : _vm._e(),
    _c("div", { staticClass: "row", attrs: { id: "title" } }, [
      _c("div", { staticClass: "col-1" }, [
        _c(
          "svg",
          {
            staticClass: "bd-placeholder-img mr-2 rounded",
            attrs: {
              id: "header",
              width: "28",
              height: "28",
              xmlns: "http://www.w3.org/2000/svg",
              preserveAspectRatio: "xMidYMid slice",
              focusable: "false",
              role: "img",
              "aria-label": "Placeholder: 32x32",
            },
          },
          [
            _c("rect", {
              attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
            }),
          ]
        ),
      ]),
      _c("div", { staticClass: "col-5" }, [
        _c("h5", [_vm._v(_vm._s(_vm.pageTitle))]),
      ]),
      _c("div", { staticClass: "col-3" }, [
        _c(
          "button",
          {
            staticClass: "btn-sm btn-outline-info",
            attrs: { id: "backBtn", type: "button" },
            on: { click: _vm.back },
          },
          [_vm._v(" キャンセルする ")]
        ),
      ]),
    ]),
    _c("div", { staticClass: "row", attrs: { id: "register_form" } }, [
      _c("div", { staticClass: "col-1" }),
      _c("div", { staticClass: "col-8" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("div", { staticClass: "row", staticStyle: { height: "130px" } }, [
            _vm._m(0),
            _c("div", { staticClass: "col-2" }, [
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.preview,
                    expression: "!preview",
                  },
                ],
                staticClass: "card-img",
                attrs: { src: "/card-image.svg" },
              }),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.preview,
                    expression: "preview",
                  },
                ],
                staticClass: "trim-circle",
                style: { backgroundImage: "url(" + _vm.preview + ")" },
                attrs: { id: "imageContainer" },
              }),
            ]),
            _c("div", { staticClass: "col-1" }),
            _c("div", { staticClass: "col-6" }, [
              _c(
                "form",
                {
                  attrs: { enctype: "multipart/form-data" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.upload.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { attrs: { id: "fileInputContainer" } }, [
                      _c(
                        "label",
                        {
                          staticClass: "fileUploadBtn",
                          attrs: { tabindex: "0" },
                        },
                        [
                          _vm._v("ファイルを選択 "),
                          _c("input", {
                            ref: "file",
                            attrs: {
                              id: "inputtag",
                              type: "file",
                              accept: "image/png, image/jpeg, image/svg+xml",
                            },
                            on: { change: _vm.selectedFile },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { attrs: { id: "fileInputLabel" } }, [
                      _vm._v(_vm._s(_vm.fileLabel)),
                    ]),
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _vm._m(1),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isUploadFile,
                            expression: "isUploadFile",
                          },
                        ],
                        staticClass: "alert alert-danger alert-margin small",
                        staticStyle: { margin: "0.5rem", padding: "0.25rem" },
                        attrs: { role: "alert" },
                      },
                      [_vm._v(" 登録ボタンを押してください ")]
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-2" }, [
      _c("label", [_vm._v("イメージ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c(
        "button",
        { staticClass: "btn btn-info setting-button-margin btn-sm" },
        [_vm._v(" 登録 ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }